import React, { useState } from 'react';
import { useReveal } from '../hooks/useReveal';

const tabs = [
	{
		label: 'Frontend',
		icon: '🎨',
		skills: ['HTML5 / CSS3', 'JavaScript', 'TypeScript', 'React.js', 'Next.js', 'React Native', 'Tailwind CSS', 'Bootstrap'],
	},
	{
		label: 'Backend',
		icon: '⚙️',
		skills: ['Node.js / Express', 'Golang / Gin', 'gRPC', 'Python / Flask', 'PostgreSQL', 'MySQL', 'MongoDB', 'REST APIs', 'Microservices', 'Event-Driven Architecture'],
	},
	{
		label: 'DevOps & Cloud',
		icon: '☁️',
		skills: ['AWS (ECS, SNS, SQS, CloudFormation)', 'Docker', 'Linux', 'GitHub Actions', 'CI/CD', 'Agile / Scrum', 'Git'],
	},
];

function Skills() {
	const [active, setActive] = useState(0);
	const ref = useReveal();

	return (
		<section className="max-w-6xl mx-auto px-6">
			<div ref={ref} className="reveal">
				{/* Tab bar */}
				<div className="flex gap-2 mb-8 p-1 glass-card w-fit rounded-2xl">
					{tabs.map((tab, i) => (
						<button key={tab.label} onClick={() => setActive(i)}
							className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 ${
								active === i
									? 'bg-accent text-white shadow-glow'
									: 'text-slate-400 hover:text-white hover:bg-white/5'
							}`}>
							<span>{tab.icon}</span>
							{tab.label}
						</button>
					))}
				</div>

				{/* Skills */}
				<div className="flex flex-wrap gap-3">
					{tabs[active].skills.map((skill, i) => (
						<span key={skill}
							className="tag text-sm px-4 py-2 cursor-default hover:bg-accent/25 hover:border-accent/50 hover:text-white transition-all duration-200"
							style={{ animationDelay: `${i * 0.05}s` }}>
							{skill}
						</span>
					))}
				</div>
			</div>
		</section>
	);
}

export default Skills;
